import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { CommonPlayerPreview } from '../CommonPlayerPreview';
import type { CommonCardsGrid_commonPlayer } from './__generated__/types.graphql';

export const commonCardsGridFragment = gql`
  fragment CommonCardsGrid_commonPlayer on CommonPlayer {
    id
    anyPlayer {
      slug
    }
    ...CommonPlayerPreview_commonPlayer
  }
  ${CommonPlayerPreview.fragments.commonPlayer}
` as TypedDocumentNode<CommonCardsGrid_commonPlayer>;
